import { render, staticRenderFns } from "./afterTheDetails.vue?vue&type=template&id=03575ac9&scoped=true&"
import script from "./afterTheDetails.vue?vue&type=script&lang=js&"
export * from "./afterTheDetails.vue?vue&type=script&lang=js&"
import style0 from "./afterTheDetails.vue?vue&type=style&index=0&id=03575ac9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03575ac9",
  null
  
)

export default component.exports